import React, { useState, useEffect } from 'react';
import { Container, Header, Segment } from 'semantic-ui-react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import './Blog.css';

const isDev = process.env.NODE_ENV === 'development';
const isDocker = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
const publicApi = axios.create({
  baseURL: isDev
    ? `http://${isDocker ? 'dijon-backend' : 'localhost'}:8019/dijon-backend/api/`
    : `https://dijondreams.com/dijon-backend/api/`,
  headers: { 'Content-Type': 'application/json' }
});

function BlogDetailPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPost() {
      try {
        const res = await publicApi.get(`blog/posts/${slug}/`);
        setPost(res.data);
      } catch (e) {
        console.error('Failed to fetch blog post:', e);
      }
      setLoading(false);
    }
    fetchPost();
  }, [slug]);

  if (loading) return <div className="blog-detail-page"><Container text><Segment loading placeholder /></Container></div>;
  if (!post) return (
    <div className="blog-detail-page">
      <Container text>
        <Segment textAlign="center">
          <Header as="h3">Post not found</Header>
          <Link to="/blog">Back to blog</Link>
        </Segment>
      </Container>
    </div>
  );

  return (
    <div className="blog-detail-page">
      <Container text>
        <Link to="/blog" style={{ marginBottom: '20px', display: 'inline-block' }}>&larr; Back to blog</Link>
        <Header as="h1">{post.title}</Header>
        <p className="blog-meta">
          {post.author_name} &middot; {new Date(post.published_at || post.created_at).toLocaleDateString()}
        </p>
        <div className="blog-content">{post.content}</div>
      </Container>
    </div>
  );
}

export default BlogDetailPage;
